export enum ObjectType {
  LOCATION = 'location',
  RATING = 'rating',
  RATING_TYPE = 'rating.type',
  PLAYER = 'player',
  PLAYER_TITLE = 'player.titled',
  GAMBIT = 'gambit',
}
